export default "__VITE_ASSET__79abdde7__"